import API_EndPoints from '../types/API_EndPoints';
const pricing_endpoint_preffix = 'api/Plans';
export const ApiEndpoints: API_EndPoints = {
	Pricing: pricing_endpoint_preffix,
};
